// extracted by mini-css-extract-plugin
export default {"card":"K2-z"};